// extracted by mini-css-extract-plugin
export default {"resizable":"DetailsView_resizable__4XMEN","details":"DetailsView_details__2Rf1Z"};